import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/LanguageContext";
import LanguageGate from "@/components/LanguageGate";
import ConsultationModal from "@/components/ConsultationModal";

function App() {
    return (
        <LanguageProvider>
            <div className="grain" data-testid="app-root">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                    </Routes>
                </BrowserRouter>
                <LanguageGate />
                <ConsultationModal />
                <Toaster
                    position="bottom-center"
                    theme="light"
                    toastOptions={{
                        style: {
                            background: "#2D2824",
                            color: "#F9F6F0",
                            border: "1px solid #B48F57",
                            borderRadius: 0,
                            fontFamily: "Manrope, sans-serif",
                            letterSpacing: "0.02em",
                        },
                    }}
                />
            </div>
        </LanguageProvider>
    );
}

export default App;
